import GeneralHeader from 'components/common/GeneralHeader';
import NewWSCalendar from 'components/tabs-components/general_settings/workshift_calendar/new_workshift_calendar';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import useMember from 'hooks/useMember';

const WorkShiftCalendarDetail = () => {

  const { getWorkShiftCalendarById } = useMember();
  const location = useLocation();
  const [fetchData, setFetchData] = useState([]);
  useEffect(() => {
    if (!isNaN(+location.state?.id))
      getWorkShiftCalendarById(location.state?.id).then((res) => {
        if (res) {
          setFetchData(res);
        }
      });
  }, []);
  return (
    <div>
      <GeneralHeader
        icon={'/icons/defalut_setting_ic.svg'}
        pageTitle={location.state.name}
        child={
          <div style={{ marginTop: '50px' }}>
            <NewWSCalendar finalData={fetchData} check={true} />
          </div>
        }
      />
    </div>
  );
};

export default WorkShiftCalendarDetail;
